import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
} from "@mui/material";
import { TextSnippet } from "@mui/icons-material";

const Formularios = () => {
  return (
    <Box>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Card sx={{ borderRadius: 4 }}>
            <CardContent>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Descarregar Formularios e Modelos
              </Typography>
              <Box
                sx={{
                  display: "grid",
                  gap: 1.5,
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(3, minmax(0, 1fr))",
                    lg: "repeat(6, minmax(0, 1fr))",
                  },
                }}
              >
                <QuickActionCard
                  icon={<TextSnippet color="primary" />}
                  title="Acordo Extrajudicial"
                  subtitle="Acordo Extrajudicial"
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href = "/Forms/ACORDO%20EXTRAJUDICIAL.docx";
                    link.download = "ACORDO EXTRAJUDICIAL.docx";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                />
                <QuickActionCard
                  icon={<TextSnippet color="primary" />}
                  title="Acta Aprovacao das contas"
                  subtitle="Acta Aprovação das Contas"
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href = "/Forms/ACTA%20APROVACAO%20DAS%20CONTAS.docx";
                    link.download = "ACTA APROVACAO DAS CONTAS.docx";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                />{" "}
                <QuickActionCard
                  icon={<TextSnippet color="primary" />}
                  title="Acta da Entrevista"
                  subtitle="Acta da Entrevista Disciplinar"
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href = "/Forms/ACTA%20DA%20ENTREVISTA.docx";
                    link.download = "ACTA DA ENTREVISTA.docx";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                />
                <QuickActionCard
                  icon={<TextSnippet color="primary" />}
                  title="Acta da Equipa Tecnica"
                  subtitle="Acta da Equipa Técnica (Embarcações)"
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href = "/Forms/ACTA%20DA%20EQUIPA%20TECNICA.docx";
                    link.download = "ACTA DA EQUIPA TECNICA.docx";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                />
                <QuickActionCard
                  icon={<TextSnippet color="primary" />}
                  title="Acta da Reuniao com TNC"
                  subtitle="Acta da Reunião com TNC"
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href = "/Forms/ACTA%20DA%20REUNIAO%20COM%20TNC.docx";
                    link.download = "ACTA DA REUNIAO COM TNC.docx";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                />
                <QuickActionCard
                  icon={<TextSnippet color="primary" />}
                  title="Acta da Reuniao"
                  subtitle="Acta da Reunião"
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href = "/Forms/ACTA%20DA%20REUNIAO.docx";
                    link.download = "ACTA DA REUNIAO.docx";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                />{" "}
                <QuickActionCard
                  icon={<TextSnippet color="primary" />}
                  title="Acto de Constituicao de sociedade por quotas da empresa"
                  subtitle="Acto de Constituicao de Sociedade por Quotas da Empresa"
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href =
                      "/Forms/ACTO%20DE%20CONSTITUICAO%20DE%20SOCIEDADE%20POR%20QUOTAS%20DA%20EMPRESA.docx";
                    link.download =
                      "ACTO DE CONSTITUICAO DE SOCIEDADE POR QUOTAS DA EMPRESA.docx";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

const QuickActionCard = ({ icon, title, subtitle, onClick }) => (
  <Card
    onClick={onClick}
    sx={{
      cursor: "pointer",
      borderRadius: 3,
      p: 1,
      height: "100%",
      transition: "0.2s",
      "&:hover": { backgroundColor: "#f4eefc" },
    }}
  >
    <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Avatar sx={{ bgcolor: "#efe5ff" }}>{icon}</Avatar>
      <Box>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
    </CardContent>
  </Card>
);

export default Formularios;
